<template>
  <div class='two-waterfall'>
    <div class='header' style='margin-top: .04rem;'>
      <div>{{ floorData.floorTitle }}</div>
      <a v-if="floorData.isMore === '0'" class='more' :href="!$isIframe ? floorData.moreUrl: 'javascript:void(0);'">
        <span>更多</span>
        <img src='@/assets/img/arrow-right.png' alt='' />
      </a>
    </div>
    <div class='gridArea'>
      <template v-if='floorData.data.length > 0'>
        <div v-for='(item, idx) in floorData.data' :key='idx'>
          <a @click='$jumpToPage(item)'>
            <div>
              <div class='gridTitle'>{{ item.title }}</div>
              <div class='gridSubTitle'>
                {{ item.subtitleFirst ? item.subtitleFirst.length > 7 ? item.subtitleFirst.substr(0, 7) : item.subtitleFirst : '' }}
              </div>
            </div>
            <img class='gridImage' :src='item.imageUrl' alt=''>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoWaterfall',
  props: ['floorData']
}
</script>

<style lang='scss' scoped>
.two-waterfall {
  padding: 0 .1rem;

  .gridArea {
    display: grid;
    width: 100%;
    grid-template-columns: 1.735rem 1.735rem;
    grid-gap: 0.08rem;

    a {
      background: white;
      border-radius: 0.04rem;
      display: flex;
      justify-content: space-between;
      padding: 0.14rem 0.087rem 0.14rem 0.1rem;

      .gridTitle {
        font-size: 0.14rem;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: left;
        color: #0d0d0d;
        line-height: 0.2rem;
        margin-bottom: 0.04rem;
      }

      .gridSubTitle {
        font-size: 0.13rem;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 0.185rem;
      }

      .gridImage {
        width: 0.43rem;
        height: 0.43rem;
      }
    }
  }
}
</style>
